import { h, Component, Prop, Host, State } from '@stencil/core';
  
window.i18n = window.i18n || {};
const buy = window.i18n['clientlibs.CFDcalculator.buy'] || 'Buy';
const contractNoStopLoss = window.i18n['clientlibs.CFDcalculator.contractNoStopLoss'] || 'contract - no stop loss*';
const trade = window.i18n['clientlibs.CFDcalculator.trade'] || 'Trade';
const tradeSize = window.i18n['clientlibs.CFDcalculator.size'] || 'Trade size';
const marginRequirement = window.i18n['clientlibs.CFDcalculator.marginRequirement'] || 'Margin requirement';
const movesDown = window.i18n['clientlibs.CFDcalculator.movesDown'] || 'moves down';
const movesUp = window.i18n['clientlibs.CFDcalculator.movesUp'] || 'moves up';
const orderSize = window.i18n['clientlibs.CFDcalculator.orderSize'] || 'With an order size of';
const ifThePriceOf = window.i18n['clientlibs.CFDcalculator.ifThePriceOf'] || 'If the price of the';
const currentPriceAt = window.i18n['clientlibs.CFDcalculator.currentPriceAt'] || ', current priced at';
const movedBy = window.i18n['clientlibs.CFDcalculator.movedBy'] || ', moved by:';
const typical = window.i18n['clientlibs.CFDcalculator.typical'] || 'typical';
const hourly = window.i18n['clientlibs.CFDcalculator.hourly'] || 'hourly';
const daily = window.i18n['clientlibs.CFDcalculator.daily'] || 'daily';
const weekly = window.i18n['clientlibs.CFDcalculator.weekly'] || 'weekly';
const monthly = window.i18n['clientlibs.CFDcalculator.monthly'] || 'monthly';
const perPoint = window.i18n['clientlibs.CFDcalculator.perPoint'] || 'per point';
const profit = window.i18n['clientlibs.CFDcalculator.profit'] || 'profit';
const loss = window.i18n['clientlibs.CFDcalculator.loss'] || 'loss';
const pts = window.i18n['clientlibs.CFDcalculator.pts'] || 'pts';
const perPointMove = window.i18n['clientlibs.CFDcalculator.perPointMove'] || 'per point move';
const to = window.i18n['clientlibs.CFDcalculator.to'] || 'to';
const howCFDworks = window.i18n['clientlibs.CFDcalculator.howCFDworks'] || 'How CFD margin works';
const getTooltip = (tooltipKey: string) => window.i18n[`clientlibs.CFDcalculator.${tooltipKey}`];

@Component({
  shadow: false,
  styleUrl: 'igws-cfd-calculator.less',
  tag: 'igws-cfd-calculator',
})
export class CalculatorComponent {
    /** 
     * Movement points
     */
    @Prop() movementPts: number = 200;

    /** 
     * Size
     */
    @Prop() size: number = 5;

    /** 
     * Spread
     */
    @Prop() spread: number = 0;

    /** 
     * current level
     */
    @Prop() currentLevel: number = 1.2100;

    /** 
     * Knock out distance
     */
    @Prop() koDistance: number = 150;

    /** 
     * CFD margin percentage
     */
    @Prop() cfdMarginPerc: number = 3.33;

    /** 
     * Product
     */
    @Prop() product!: string;

    /** 
     * Currency
     */
    @Prop() currency!: string;

    @State() cfdBuyPrice = 0;
    @State() cfdSellPrice = 0;
    @State() cfdMargin = 0;
    @State() cfdMarginDiff = 0;
    @State() cfdLoss = 0;
    @State() resultingUp = 0;
    @State() resultingDown = 0;
    @State() whatIsKO = '';
    @State() cfdProfit = 0;
    @State() barriersProfit = 0;

    componentWillLoad() {
        this.updateValues(this.movementPts, this.size);
    }

    handleUpdates(event: UIEvent) {
        const eTarget = event.target as HTMLInputElement;
        this.movementPts = eTarget.name === 'movementOptions' ? parseInt(eTarget.value, 10) : this.movementPts;
        this.size = eTarget.name === 'sizeOptions' ? parseInt(eTarget.value, 10) : this.size;
        this.updateValues(this.movementPts, this.size);
        this.updateCssClasses(eTarget.parentNode as HTMLElement);
    }

    updateCssClasses(activeElement: HTMLElement) {
        const parentNode = activeElement.parentNode as HTMLElement;
        const elems: any = parentNode.querySelectorAll(`label`);
        for(const el of elems){
            el.classList.remove('active');
        }
        activeElement.classList.add('active');
        activeElement.focus();
    }

    updateValues (movementPts: number, size: number) {
        this.cfdBuyPrice = this.currentLevel + (this.spread / 2);
        this.cfdSellPrice = this.currentLevel - (this.spread / 2);
        this.cfdMargin = size * (this.currentLevel * 10000) * (this.cfdMarginPerc / 100); // 2$ a point calculation is: 2 x 12100 x 3.33% = $805.86
        this.resultingUp = this.currentLevel + movementPts / 10000;
        this.resultingDown = this.currentLevel - movementPts / 10000;
        this.cfdLoss = (movementPts * size) + size;
        this.cfdProfit= (movementPts * size) - size;
    }

    render() {
        return (
            <Host>
                <section>
                    <div class="row">
                        <div class="col-sm">
                            <h6>{ifThePriceOf} {this.product}{currentPriceAt} <strong class="currentLevel">{this.currentLevel.toFixed(4)}</strong>{movedBy}</h6>
                            <div class="btn-group btn-group-toggle movementSection" data-toggle="buttons">
                                {[50, 100, 200, 350, 500].map(option => 
                                    <label class={`btn btn-outline-info ${option === this.movementPts ? 'active' : ''}`}>
                                        <input type="radio" name="movementOptions" id={`option${option}`} value={option} 
                                        onChange={(event) => this.handleUpdates(event as UIEvent)} /> {option} {pts} 
                                        <small>{typical}
                                            {option === 50 ? ` ${hourly}` : 
                                            (option === 100 || option === 200) ? ` ${daily}` : 
                                             option === 350 ? ` ${weekly}` : ` ${monthly}`}
                                        </small>
                                    </label>
                                )}
                            </div>
                        </div>
                        <div class="col-sm">
                            <h6>{orderSize}:</h6>
                            <div class="btn-group btn-group-toggle sizeSection" data-toggle="buttons">
                                {[1, 2, 5, 10, 25].map(sizeOption => 
                                    <label class={`btn btn-outline-info ${sizeOption === this.size ? 'active' : ''}`}>
                                        <input type="radio" name="sizeOptions" id={`option${sizeOption}`} value={sizeOption} 
                                        onChange={(event) => this.handleUpdates(event as UIEvent)}/> {this.currency}{sizeOption} 
                                        <small>{perPoint}</small>
                                    </label>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <table class="table">
                        <thead>
                        <tr>
                            <th>
                                {trade} 
                            </th>
                            <th>
                                {buy} {this.product} {contractNoStopLoss}
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th scope="row">
                                {tradeSize} 
                                {getTooltip("tooltip.tradeSize") ? (<span class="tooltip-trigger">
                                    <span class="tooltip-icon">?</span>
                                    <span class="tooltip-content">{getTooltip("tooltip.tradeSize")}</span>
                                </span>) : ''}
                                </th>
                            <td><span class="size"><strong>{this.currency}{this.size.toFixed(2)}</strong></span> {perPointMove}</td>
                        </tr>
                        <tr>
                            <th scope="row">
                                {marginRequirement}
                                {getTooltip("tooltip.marginReq") ? (<span class="tooltip-trigger">
                                    <span class="tooltip-icon">?</span>
                                    <span class="tooltip-content">{getTooltip("tooltip.marginReq")}</span>
                                </span>) : ''}
                            </th>
                            <td>
                                <h4 class="red">{this.currency}<span class="cfdMargin">{this.cfdMargin.toFixed(2)}</span> </h4>
                                {getTooltip("tooltip.cfd") ? (
                                <small> <span class="tooltip-trigger">
                                    {howCFDworks}
                                    <span class="tooltip-content">{getTooltip("tooltip.cfd")}</span>
                                </span>
                                </small>) : ''}
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">
                                {this.product} <span class="blue movementPts">{movesUp} {this.movementPts}</span> {pts} 
                                {getTooltip("tooltip.profit") ? (<span class="tooltip-trigger">
                                    <span class="tooltip-icon">?</span>
                                    <span class="tooltip-content">{getTooltip("tooltip.profit")}</span>
                                </span>) : ''}
                                <small>{to} <span class="resultingUp">{this.resultingUp.toFixed(4)}</span></small> 
                            </th>
                            <td><h4>{this.currency}<span class="cfdProfit">{this.cfdProfit.toFixed(2)}</span> {profit}</h4></td>
                        </tr>
                        <tr>
                            <th scope="row">
                                {this.product} <span class="red movementPts">{movesDown} {this.movementPts}</span> {pts} 
                                {getTooltip("tooltip.loss") ? (<span class="tooltip-trigger">
                                    <span class="tooltip-icon">?</span>
                                    <span class="tooltip-content">{getTooltip("tooltip.loss")}</span>
                                </span> ) : ''}
                                <small>{to} <span class="resultingDown">{this.resultingDown.toFixed(4)}</span></small>
                            </th>
                            <td>
                            <h4>
                                {this.currency}
                                <span class="cfdLoss">{this.cfdLoss.toFixed(2)}</span> {loss}
                            </h4>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </section>
            </Host>
        );
    }
}
